import { GetHv, PostHv } from './helpers';

/**
 * 
 * @param session the UUID of the session
 * @param token bl-profile-token only optional if registration is OFF
 * @returns uuid of the user sessions
 */
export async function GetUserSession(
	session: number,
	token?: string,
	registration_id?: string
): Promise<{ uuid: string | null, session: number, getUserSessionError: string | null }> {
	const params = new URLSearchParams();

	if (navigator.language) {
		params.set('lang', navigator.language);
	}

	if (registration_id) {
		params.set('registration_id', registration_id);
	}

	const data = await GetHv(`/e3-generate-session/${session}?${params.toString()}`, token);

	if (data?.message && !data?.uuid) {
		return { uuid: null, session, getUserSessionError: data.message };
	}

	return { uuid: data.uuid, session, getUserSessionError: null };
}

/**
 * Updates the end time for the current session. Fires and forgets.
 * @param uuid The uuid of the current session
 * @returns empty object
 */
export async function UpdateUserSessionEndTime(uuid: string): Promise<any> {
	PostHv('/e3-update-end-time', { uuid }, undefined, true);

	return {};
}